import styled from 'styled-components';

const CountrySelectorList = styled.ul`
  margin: 0px;
  list-style-type: none;
`;

export default CountrySelectorList;
